import { defineStore } from "pinia";

import { ref, computed } from 'vue'

import axios from 'axios'

export const useUploadStore = defineStore('useUploadStore', () => {

  const selectedFiles = ref([]);

  const errorMsg = ref("");

  const isUploading = computed(() =>
    selectedFiles.value.some((file) => file.status == "uploading")

  );

  const pending_count = computed(() =>
    selectedFiles.value.filter(file => file.status == "pending").length

  );

  const failed_count = computed(() =>
    selectedFiles.value.filter(file => file.status == "failed").length

  );

  const success_count = computed(() =>
    selectedFiles.value.filter(file => file.status == "success").length

  );

  const onSelectFiles = (event) => {
    const target = event.target;
    if (target.files === null) {
      return;
    }

    clearFiles();

    Array.from(target.files).forEach((file) => {
      selectedFiles.value.push({
        file: file,
        percentage: 0,
        status: "pending",
      });
    });
  };

  const clearFiles = () => {
    selectedFiles.value = []
    errorMsg.value = ""
  };

  const uploadFile = ( file, onUploadProgress, event_key, event_watermark_hori, event_watermark_vertical, user_id, event_id,server_upload_url_text,server_upload_url_aws,is_free_download, is_add_watermark_for_free_download,is_event_stage,event_stage,is_mhao,is_hybrid,is_mhao_hybrid,is_image_addjustment) => {

     if(Number(file.size/10000).toFixed(0) < Number(15)){
       return new Promise((resolve, reject) => {
          errorMsg.value = "***ขนาดไฟล์ต้องไม่ต่ำกว่า 150KB"
          reject("ขนาดไฟล์ต้องไม่ต่ำกว่า 150KB");
        });
      
    }
    return axios.post("v1/upload/idp", {
      event_id: event_id,
      photographer_id: user_id,
      original_file_name: file.name
    })
    .then((response) => {
      if(response.data.is_duplicate === 'Y'){
        return "skip"
      }else{
        return axios.post("v1/upload/sign", {
          event_key: event_key,
          file_name: file.name,
          file_type: "image/jpg"
        },)
        .then((presigned_response) => {
          return axios.put(presigned_response.data.url, file, {
            headers: {
              "Content-Type": "image/jpg",
              "Content-Disposition": `inline; filename="${presigned_response.data.file_name}"`,
            },
            onUploadProgress,
          })
          .then((put_response) => {

            if(put_response.status === 200){
              return axios.post("v1/upload/check", {
              photographer_id: user_id,
              event_key: event_key,
              event_id: event_id,
              event_watermark_hori: event_watermark_hori,
              event_watermark_vertical: event_watermark_vertical,
              is_free_download: is_free_download,
              is_add_watermark_for_free_download: is_add_watermark_for_free_download,
              is_event_stage: is_event_stage,
              event_stage: event_stage,
              new_file_name: presigned_response.data.file_name,
              original_file_name: file.name,
              is_mhao: is_mhao,
              is_hybrid: is_hybrid,
              is_mhao_hybrid: is_mhao_hybrid,
              is_image_addjustment: is_image_addjustment
            })
            .then((prepare_response) => {
            });
            }    
            
          });


        });
      }
    }); 
  };

  const sleep_only = async () => {
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        resolve(true)
      },20)
    });
  }

  const sleep_upload_slow_upload = async () => {
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        resolve(true)
      }, 500)
    });
  }

  const sleep_upload_slow_upload_api = async () => {
    return new Promise((resolve, reject) => {
        return axios.get("https://yjdxyhjl7eirggm42hjju74ze40nfxyx.lambda-url.ap-southeast-1.on.aws", null,)
        .then((response) => {
          resolve(true)       
        });
    });
  }

  const call_upload_file = ( file, event_key, event_watermark_hori, event_watermark_vertical, user_id, event_id,server_upload_url_text,server_upload_url_aws,is_free_download,is_add_watermark_for_free_download,is_event_stage,event_stage,is_mhao,is_hybrid,is_mhao_hybrid,is_image_addjustment) => {

    return new Promise((resolve, reject) => {
      file.status = "uploading";
      file.percentage = 0;
      uploadFile( file.file, (event) => {
        file.percentage = Math.round((100 * event.loaded) / event.total);
      }, event_key, event_watermark_hori, event_watermark_vertical, user_id, event_id,server_upload_url_text,server_upload_url_aws,is_free_download,is_add_watermark_for_free_download,is_event_stage,event_stage,is_mhao,is_hybrid,is_mhao_hybrid,is_image_addjustment)
        .then((response) => {
          file.status = "success";
          resolve(true)
        })
        .catch(() => {
          file.status = "failed";
          resolve(false)
        });
    });
  }

  const uploadSelectedFiles = async (event_key, event_watermark_hori, event_watermark_vertical, user_id, event_id,server_upload_url_text,
    server_upload_url_aws,is_free_download, is_add_watermark_for_free_download,is_event_stage,event_stage,is_mhao,is_hybrid,is_mhao_hybrid,credit_balance,is_image_addjustment) => {

    if(is_hybrid === 'Y' && is_mhao_hybrid === 'N'){
      let check_pending = selectedFiles.value.filter(file => file.status == "pending").length 
      if(check_pending > credit_balance){
        alert("เครดิตสำหรับการ upload ไม่เพียงพอกรุณาเติมเครดิต")
        return false;
      }
    }
    let check_failed = selectedFiles.value.filter(file => file.status == "failed").length
    let check_success = selectedFiles.value.filter(file => file.status == "success").length
    if (check_success === selectedFiles.value.length) {
      if(check_success===0){
        alert("Please choose file befor upload")
      }else{
        alert("All files uploaded")
      }
    }else if(is_event_stage === 'Y' && event_stage===0){
      alert("Please choose stages,location befor upload")
    } else {

      if (check_failed > 0) {
        //retry only fial
        let counter = 0
        let array_size = selectedFiles.value.length;
        while (counter < array_size) {
          let _uploading_count = selectedFiles.value.filter(file => file.status == "uploading").length
          if(_uploading_count <= 10){

            if (selectedFiles.value.length > 0) {
              let file = selectedFiles.value[counter];
              if(file.status !== 'success'){
                 call_upload_file( file, event_key, event_watermark_hori, event_watermark_vertical, user_id, event_id,server_upload_url_text,server_upload_url_aws,is_free_download, is_add_watermark_for_free_download,is_event_stage,event_stage,is_mhao,is_hybrid,is_mhao_hybrid,is_image_addjustment)
              }
            }
            counter++
          }else{
            await sleep_upload_slow_upload_api();
          }
        }
      } else {
        let counter = 0;
        let array_size = selectedFiles.value.length;
        let thead_upload = 10;
        while (counter < array_size) {
          let _uploading_count = selectedFiles.value.filter(file => file.status == "uploading").length
          if(_uploading_count <= thead_upload){
            if (selectedFiles.value.length > 0) {
              let file = selectedFiles.value[counter];
              if(file.status !== 'success'){
                call_upload_file( file, event_key, event_watermark_hori, event_watermark_vertical, user_id, event_id,server_upload_url_text,server_upload_url_aws,is_free_download, is_add_watermark_for_free_download,is_event_stage,event_stage,is_mhao,is_hybrid,is_mhao_hybrid,is_image_addjustment)
              }
            }
            counter++
        }else{
          await sleep_upload_slow_upload_api();
        }
        }
      }
    }
  }

  return { selectedFiles, isUploading, pending_count,  failed_count, success_count, onSelectFiles, clearFiles, uploadSelectedFiles, errorMsg }
});